import React from 'react';
import { CheckIcon, FileTextIcon, VideoIcon } from 'lucide-react';
import { agent, callTopics, materials } from '../../data/content';
import { CtaButton } from '../ui/CtaButton';
export function PackIncludes() {
  return <section aria-labelledby="incluye-title" className="w-full bg-ink-850" data-id="element-115" data-mp="af0f7tk5zj48">
      <div className="mx-auto max-w-5xl px-5 py-16 text-center md:py-24" data-id="element-116" data-mp="ehwtx96l2v2w">
        <h2 id="incluye-title" className="font-display text-3xl font-black leading-tight text-white md:text-[2.75rem]" data-id="element-117" data-mp="jghrf0ugb0nn">
          ¿Qué incluye el pack?
        </h2>

        <article className="mx-auto mt-10 max-w-3xl rounded-3xl border-2 border-brand-green/60 bg-ink-card p-6 shadow-panel md:p-10" data-id="element-118" data-mp="t6b4656bxlth">
          <div className="flex flex-col items-center gap-3" data-id="element-119" data-mp="y5nqmotagqvj">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand-green text-black" data-id="element-120" data-mp="126zil0zmxo6w">
              <VideoIcon className="h-5 w-5" aria-hidden="true" data-id="element-121" data-mp="175swguiu3h7l" />
            </span>
            <span className="rounded-full bg-ink-950 px-3 py-1 text-xs font-bold text-brand-greenSoft" data-id="element-122" data-mp="1g764juocco1t">
              30 minutos
            </span>
          </div>
          <h3 className="mt-5 font-display text-2xl font-black text-white md:text-3xl" data-id="element-123" data-mp="1c3zqi0uzlsks">
            Videollamada personalizada
          </h3>
          <p className="mx-auto mt-3 max-w-2xl text-[16px] leading-relaxed text-body" data-id="element-124" data-mp="127d7ziq4vdlx">
            Una videollamada de 30 minutos con {agent.name}, Agente FIFA especialista en gestión y
            representación deportiva, y Director Técnico con Licencia PRO ATFA-CONMEBOL. Se analiza
            el caso particular del futbolista.
          </p>
          <p className="mt-7 text-sm font-bold text-white" data-id="element-125" data-mp="1q410q6x56ccx">Podés consultar sobre:</p>
          <ul className="mt-4 flex flex-wrap justify-center gap-2" data-id="element-126" data-mp="1l57n8ehuulcr">
            {callTopics.map(topic => <li key={topic} className="inline-flex items-center gap-1.5 rounded-full border border-ink-border bg-ink-950 px-3.5 py-2 text-[14px] text-body" data-id="element-127" data-mp="2imep7fwl8lzc">
                <CheckIcon className="h-3.5 w-3.5 shrink-0 text-brand-green" strokeWidth={3} aria-hidden="true" data-id="element-128" data-mp="bxwaadil6t0q" />
                {topic}
              </li>)}
          </ul>
        </article>

        <div className="mx-auto mt-16 max-w-2xl" data-id="element-129" data-mp="271lb1dyhfbl">
          <p className="inline-flex items-center gap-2 font-bold text-white" data-id="element-130" data-mp="76e9bpgkcsfr">
            <FileTextIcon className="h-5 w-5 text-brand-gold" aria-hidden="true" data-id="element-131" data-mp="74b96clp5ixb" />
            Material complementario incluido en PDF
          </p>
          <p className="mt-3 text-[16px] leading-relaxed text-body" data-id="element-132" data-mp="3tex9i22yawqr">
            <strong className="font-bold text-brand-gold" data-id="element-133" data-mp="3fecsnbgljazw">+200 páginas</strong> de información
            sobre lo que un padre necesita saber del mundo del fútbol.
          </p>
        </div>

        <ol className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-134" data-mp="1dmzowpqd795f">
          {materials.map((material, index) => <li key={material.title} className="flex flex-col items-center rounded-2xl border border-ink-border bg-ink-card px-6 py-7" data-id="element-135" data-mp="1iljfj3fwl944" data-mpi={index}>
              <span className="font-display text-2xl font-black text-brand-gold" data-id="element-136" data-mp="1sndidhnq3iib">{index + 2}</span>
              <h3 className="mt-2 font-bold text-white" data-id="element-137" data-mp="1notx7jgyear0">{material.title}</h3>
              <p className="mt-2 text-[15px] leading-relaxed text-subtle" data-id="element-138" data-mp="21jcu5fe4om1x">{material.description}</p>
            </li>)}
        </ol>

        <div className="mt-12 flex justify-center" data-id="element-139" data-mp="2bfzd1ymw931b">
          <CtaButton size="xl" data-id="element-140" data-mp="2beehc5oufe1v" />
        </div>
      </div>
    </section>;
}